import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsFullScreenExitNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M1 6h3.375C5.272 6 6 5.272 6 4.375V1H4.75v3.375a.375.375 0 01-.375.375H1zM15 6V4.75h-3.375a.375.375 0 01-.375-.375V1H10v3.375C10 5.272 10.728 6 11.625 6zM15 10h-3.375c-.897 0-1.625.728-1.625 1.625V15h1.25v-3.375c0-.207.168-.375.375-.375H15zM1 10v1.25h3.375c.207 0 .375.168.375.375V15H6v-3.375C6 10.728 5.272 10 4.375 10z" />
      </g>
    </svg>
  )
);
SvgActionsFullScreenExitNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsFullScreenExitNormalXsmall;
